import { User } from '@stax-core/types-omni';

import {
  AccountFieldsValues,
  AccountFieldsErrors,
} from './AccountFields.types';
import { isValidEmail } from '../../util/validator.util';
import { testPassword } from '../../util/password.util';

export function mapFormValuesToPayload(
  formValues: AccountFieldsValues,
): Partial<User> {
  return {
    email: formValues.email,
    password: formValues.password,
    password_confirmation: formValues.password,
  };
}

export function mapUserToInitialFormValues(user: User | null | undefined): AccountFieldsValues {
  return {
    email: user?.email || '',
    password: '',
    password_confirmation: '',
    // not part of the user values
    showPassword: false,
  };
}

export function validateFormValues(
  formValues: AccountFieldsValues,
): AccountFieldsErrors {
  const formErrors = {} as AccountFieldsErrors;

  if (!formValues.email) {
    formErrors.email = 'Required';
  } else if (!isValidEmail(formValues.email)) {
    formErrors.email = 'Please use a valid email';
  }

  if (!formValues.password) {
    formErrors.password = 'Required';
  } else if (!testPassword(formValues.password).pass) {
    formErrors.password = 'Please use a stronger password';
  }

  return formErrors;
}

export function isAccountPageHidden(
  userAcknowledgments: User['acknowledgments'],
) {
  return !!userAcknowledgments?.setPassword;
}
